import { render, staticRenderFns } from "./requestChart.vue?vue&type=template&id=71bdf717&scoped=true"
import script from "./requestChart.vue?vue&type=script&lang=js"
export * from "./requestChart.vue?vue&type=script&lang=js"
import style0 from "./requestChart.vue?vue&type=style&index=0&id=71bdf717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdf717",
  null
  
)

export default component.exports